import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";
import InputValidator from "../../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../../form/input/InputValidatorI";

export default class VorschFreitextValidator implements InputValidatorI {

    static MAX_LENGTH = 900;

    private value?: string;

    constructor(newValue?: string) {
        this.value = newValue;
    }

    validate(): InputValidationStateBo {
        // *** is blank
        if (InputValidator.isBlank(this.value)) {
            return InputValidationStateBo.createInValid("Bitte machen Sie Angaben zu Ihren Vorschäden.")
        }

        // *** Wert is gueltig!
        return InputValidationStateBo.createValid();
    }

}